var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { feathersServices } from 'src/feathers';
import Page from '../../templates/Page';
import FormRound from './FormRound';
var FormRoundPage = (function (_super) {
    __extends(FormRoundPage, _super);
    function FormRoundPage(props) {
        var _this = _super.call(this, props) || this;
        var roundId = props.match.params.roundId;
        var store = props.store;
        _this.state = _this.filterData(store, roundId);
        _this.handleCreateRound = _this.handleCreateRound.bind(_this);
        _this.handlePatchRound = _this.handlePatchRound.bind(_this);
        _this.handleDeleteRound = _this.handleDeleteRound.bind(_this);
        _this.navigateTo = _this.navigateTo.bind(_this);
        return _this;
    }
    FormRoundPage.prototype.componentWillReceiveProps = function (nextProps) {
        var roundId = nextProps.match.params.roundId;
        var store = nextProps.store;
        this.setState(this.filterData(store, roundId));
    };
    FormRoundPage.prototype.filterData = function (store, roundId) {
        var fCategory;
        var fRoutes;
        var fRound = store.rounds.find(function (r) { return r.id === roundId; });
        if (fRound) {
            fCategory = store.categories.find(function (c) { return c.id === fRound.categoryId; });
            fRoutes = store.routes.filter(function (r) { return r.roundId === roundId; });
        }
        return {
            category: fCategory,
            round: fRound,
            routes: fRoutes,
        };
    };
    FormRoundPage.prototype.handleCreateRound = function (round) {
        return this.props.dispatch(feathersServices.rounds.create(round));
    };
    FormRoundPage.prototype.handlePatchRound = function (round) {
        return this.props.dispatch(feathersServices.rounds.patch(round.id, round));
    };
    FormRoundPage.prototype.handleDeleteRound = function (round) {
        return this.props.dispatch(feathersServices.rounds.remove(round.id));
    };
    FormRoundPage.prototype.navigateTo = function (path) {
        this.props.dispatch(push(path));
    };
    FormRoundPage.prototype.render = function () {
        var event = this.props.store.event;
        var round = this.state.round;
        var documentTitle = round
            ? "Editing " + round.name
            : 'Setup a new round';
        return (React.createElement(Page, { documentTitle: documentTitle + " | " + event.nameShort, pageTitle: round ? round.name : 'Setup new round', pageContentMaxWidth: '1024px', pageNavigateLink: "/event/" + event.subdomain + "/rounds", pageNavigateText: 'Rounds' },
            React.createElement(FormRound, { user: this.props.store.user, event: this.props.store.event, categories: this.props.store.categories, category: this.state.category, round: this.state.round, routes: this.state.routes, handleCreateRound: this.handleCreateRound, handlePatchRound: this.handlePatchRound, handleDeleteRound: this.handleDeleteRound, navigateTo: this.navigateTo })));
    };
    return FormRoundPage;
}(React.Component));
var mapStateToProps = function (state) { return ({
    store: {
        user: state.workspaceMain.user && state.workspaceMain.user.data[0],
        event: state.workspaceEvent.event && state.workspaceEvent.event.data[0],
        categories: state.workspaceEvent.categories && state.workspaceEvent.categories.data,
        rounds: state.workspaceEvent.rounds && state.workspaceEvent.rounds.data,
        routes: state.workspaceEvent.routes && state.workspaceEvent.routes.data,
    },
}); };
export default connect(mapStateToProps)(FormRoundPage);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormRoundPage/index.tsx
// module id = 1183
// module chunks = 0